/**
 * Application Configuration — Admin
 *
 * Central source of truth for environment variables.
 */

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

if (import.meta.env.PROD && !API_BASE_URL) {
  // API_BASE_URL not set in production — requests will use relative paths
}
